// src/components/BackgroundEditor.jsx

import React from 'react';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

const backgroundOptions = [
  { name: 'שחור', value: 'bg-gray-900' },
  { name: 'אפור', value: 'bg-gray-500' },
  { name: 'לבן', value: 'bg-white' },
];

const PencilIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.536L16.732 3.732z" />
    </svg>
);

const BackgroundEditor = ({ effectiveUserId, currentBackground, onBackgroundChange }) => {
  const handleSelect = async (bgClass) => {
    if (!effectiveUserId) return;
    
    // 1. עדכון מיידי של התצוגה באפליקציה
    onBackgroundChange(bgClass); 
    
    // 2. שמירת הבחירה בפיירבייס
    try {
      const settingsRef = doc(db, 'users', effectiveUserId, 'settings', 'main');
      await setDoc(settingsRef, {
        display: { backgroundColor: bgClass }
      }, { merge: true });
    } catch (error) {
      console.error("Error saving background color:", error);
    }
  };

  return (
    <div className="p-4 my-4 border-t border-b border-gray-700">
        <div className="flex items-center justify-center gap-2 mb-3">
            <PencilIcon />
            <h3 className="text-lg font-semibold text-white">ערוך רקע</h3>
        </div>
        <div className="flex justify-center items-center gap-4">
            {backgroundOptions.map(option => (
            <div key={option.name} className="flex flex-col items-center gap-1">
                <button
                    onClick={() => handleSelect(option.value)}
                    className={`w-16 h-10 rounded-lg border-2 transition-all duration-200 ${option.value} ${currentBackground === option.value ? 'border-amber-400 scale-110' : 'border-gray-600'}`}
                    aria-label={`בחר רקע ${option.name}`}
                />
                <input
                    type="radio"
                    name="background-option"
                    checked={currentBackground === option.value}
                    onChange={() => handleSelect(option.value)}
                    className="h-4 w-4 text-amber-500 focus:ring-amber-500"
                />
            </div>
            ))}
        </div>
    </div>
  );
};

export default BackgroundEditor;
